<template>
    <div class="col-sm-4">Assessment Method</div>
    <div class="col-sm-8">
        <div class="col-sm-12">
            <select class="form-select" v-model="assessment" @change="changeAssessment">
                <option value="">Select</option>
                <option v-for="st in options" :key="st.Id" :value="st.Id">
                    {{ st.Name }}
                </option>
            </select>
        </div>
        <div class="col-sm-12 text-end" v-if="false && assessment != ''">
            <a href="#" class="link10 modspec_font10">Download sample {{ nameAssessment }} report</a>
        </div>
    </div>
</template>
<script>
import { inject } from 'vue'
import data from "../../helpers/data.json";

export default {
    name: "nq-assessment",
    //inject:['hayItem'],
    data: function () {
        return {
            serviceTypes: data.serviceTypes,
            assessment: ''
        }
    },
    /*
    Options should include: [6x options]: DTS (NCC19) / DTS (NCC22) / JV3 (NCC19) / J1V3 (NCC22) / Performance Solution Handbook (NCC19) / Performance Solution Handbook (NCC22)
    */
    mounted() {

    },
    methods: {
        setAssessmentById(id) {
            this.assessment = id == null ? '' : parseInt(id);
            this.changeAssessment();
        },
        changeAssessment() {
            let select = { Id: '', Name: '' };
            if (this.assessment != '') {
                select = this.serviceTypes.find(x => x.Id == parseInt(this.assessment));
            }
            this.$emit('setAssessment', select);
        }
    },
    computed: {
        hayItems() {
            let hay = inject('hayItem')
            return hay.value;
        },
        nameAssessment() {
            let select = this.serviceTypes.find(x => x.Id == parseInt(this.assessment));
            return select.Name;
        },
        options() {
            let st = data.serviceTypes;
            if (this.hayItems) {
                return st.filter(c => (c.Id != 5 && c.Id != 6))
            }
            return st
        }
    }
}
</script>
<style scoped>
.form-select {
    font-size: 12px !important;
}
</style>
